import UPWeekPicker from './UPWeekPicker';

export default UPWeekPicker;
